<template>
  <div class="flex gap-4 w-full items-center" :class="containerClass">
    
    <!-- Texto para desktop SOLO en PLP -->
    <div v-if="isPlpRoute" class="hidden md:flex flex-col justify-center min-w-[180px]">
      <p class="text-base font-semibold text-gray-800 text-center">Cambiar medidas</p>
    </div>

    <!-- Neumático curvo - Siempre visible EXCEPTO en desktop PLP -->
    <div v-if="!isPlpRoute || !isDesktop" class="flex flex-col items-center" :class="{'md:hidden': isPlpRoute}">
      <NeumaticoCurvo />
    </div>

    <!-- Contenedor de selectores que ocupa todo el espacio disponible -->
    <div class="grid grid-cols-3 gap-4 w-full">
      <!-- Selector Ancho -->
      <SelectMasInput 
        :disableAutoScroll="disableAutoScroll"
        :isOpen="selectedSearch === 'Ancho'" 
        @setSelectMasInput="setSelectMasInputWidth" 
        :placeholderName="'Ancho'"
        :data="widths" 
        :selectedValue="selectedWidth"
        @changeValue="onChangeWidth" 
        :isLoading="loadingWidths" 
        :isMeasure="true"
        :hasNumberValidation="true" 
        :maxNumberLength="3" 
        :isEnabled="true"
        :shouldHighlight="!selectedWidth"
      />

      <!-- Selector Perfil -->
      <SelectMasInput 
        :disableAutoScroll="disableAutoScroll"
        :isOpen="selectedSearch === 'Perfil'" 
        @setSelectMasInput="setSelectMasInputTireProfile"
        :placeholderName="'Perfil'" 
        :data="perfiles"
        :selectedValue="selectedTireProfile"
        @changeValue="onChangeTireProfile" 
        :isLoading="loadingperfiles"
        :isMeasure="true" 
        :hasNumberValidation="true" 
        :maxNumberLength="3" 
        :isEnabled="!!selectedWidth"
        :shouldHighlight="!!selectedWidth && !selectedTireProfile"
      />

      <!-- Selector Aro -->
      <SelectMasInput 
        :disableAutoScroll="disableAutoScroll"
        :isOpen="selectedSearch === 'Aro'" 
        @setSelectMasInput="setSelectMasInputRing" 
        :placeholderName="'Aro'"
        :data="rings"
        :selectedValue="selectedRing"
        @changeValue="onChangeRing" 
        :isLoading="loadingRings" 
        :isMeasure="true"
        :hasNumberValidation="true" 
        :maxNumberLength="3" 
        :isEnabled="!!selectedTireProfile"
        :shouldHighlight="!!selectedTireProfile && !selectedRing"
      />
    </div>

  </div>
</template>

<script setup>
import SelectMasInput from "~/components/Selectores/SelectMasInput.vue";
import NeumaticoCurvo from "~/components/Neumaticos/NeumaticoCurvo.vue";

const route = useRoute();

// PROPS QUE RECIBE EL COMPONENTE
const props = defineProps({
  selectedSearch: {
    type: String,
    required: true
  },
  widths: {
    type: Array,
    required: true
  },
  perfiles: {
    type: Array,
    required: true
  },
  rings: {
    type: Array,
    required: true
  },
  loadingWidths: {
    type: Boolean,
    default: false
  },
  loadingperfiles: {
    type: Boolean,
    default: false
  },
  loadingRings: {
    type: Boolean,
    default: false
  },
  disableAutoScroll: {
    type: Boolean,
    default: false
  },
  selectedWidth: {
    type: [String, Number],
    default: ""
  },
  selectedTireProfile: {
    type: [String, Number],
    default: ""
  },
  selectedRing: {
    type: [String, Number],
    default: ""
  },
  // NUEVO PROP PARA CLASES DEL CONTENEDOR
  containerClass: {
    type: [String, Array, Object],
    default: ""
  }
});

// COMPUTED PARA DETECTAR RUTA
const isPlpRoute = computed(() => {
  return route.path.includes('/neumaticos/plp');
});

// COMPUTED PARA DETECTAR DESKTOP
const isDesktop = ref(false);

const checkViewport = () => {
  isDesktop.value = window.innerWidth >= 768;
};

onMounted(() => {
  checkViewport();
  window.addEventListener('resize', checkViewport);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkViewport);
});

// EVENTOS QUE EMITE EL COMPONENTE
const emit = defineEmits([
  'setSelectMasInputWidth',
  'setSelectMasInputTireProfile', 
  'setSelectMasInputRing',
  'onChangeWidth',
  'onChangeTireProfile',
  'onChangeRing'
]);

// EMITE EVENTO CUANDO SE HACE CLICK EN SELECTOR ANCHO
const setSelectMasInputWidth = (value) => {
  emit('setSelectMasInputWidth', value);
};

// EMITE EVENTO CUANDO SE HACE CLICK EN SELECTOR PERFIL
const setSelectMasInputTireProfile = (value) => {
  emit('setSelectMasInputTireProfile', value);
};

// EMITE EVENTO CUANDO SE HACE CLICK EN SELECTOR ARO
const setSelectMasInputRing = (value) => {
  emit('setSelectMasInputRing', value);
};

// EMITE EVENTO CUANDO CAMBIA EL ANCHO
const onChangeWidth = (value) => {
  emit('onChangeWidth', value);
};

// EMITE EVENTO CUANDO CAMBIA EL PERFIL
const onChangeTireProfile = (value) => {
  emit('onChangeTireProfile', value);
};

// EMITE EVENTO CUANDO CAMBIA EL ARO
const onChangeRing = (value) => {
  emit('onChangeRing', value);
};
</script>